var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.059,
    height: 41.059,
    viewBox: "0 0 41.059 41.059",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-play-circle",
    "data-name": "Icon awesome-play-circle",
    d: "M21.092.563a20.53,20.53,0,1,0,20.53,20.53A20.526,20.526,0,0,0,21.092.563ZM30.67,23.079,16.1,31.44A1.99,1.99,0,0,1,13.145,29.7V12.483A1.991,1.991,0,0,1,16.1,10.745L30.67,19.6A1.993,1.993,0,0,1,30.67,23.079Z",
    transform: "translate(-0.563 -0.563)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.ab273df7965a422419632c14d2ebd557.svg";
export { ForwardRef as ReactComponent };